import React from '../vendor/react';
import { useState } from '../vendor/react';
import { ArrowRight, Building2, CircleCheck, MapPin, Store } from '../vendor/lucide-react';
import { navigate } from '../vendor/react-router-dom';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { useWorkspace } from '../features/workspace/useWorkspace';
import { useSaas } from '../features/saas/useSaas';

export function ContextSelectorPage() {
  const workspace = useWorkspace();
  const saas = useSaas();
  const [error, setError] = useState('');
  const current = workspace.workspace?.activeContext;

  const select = async (organizationId: string, businessId: string, branchId: string) => {
    setError('');
    try {
      await workspace.actions.switchContext({ organizationId, businessId, branchId });
      navigate('/app', { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'No se pudo cambiar de sucursal.');
    }
  };

  return (
    <div className="page-stack context-page">
      <section className="context-heading"><div><span>Contexto de trabajo</span><h2>Elige dónde vas a operar</h2><p>La selección limita los datos visibles al negocio y sucursal autorizados para tu cuenta.</p></div><Badge tone="success">Sesión protegida</Badge></section>
      {error && <div className="inline-error">{error}</div>}
      <div className="context-organizations">{workspace.workspace?.organizations.map((organization) => {
        const allBusinesses = workspace.workspace?.businesses.filter((item) => item.organizationId === organization.id) ?? [];
        const businesses = saas.hasFeature('multiBusiness') ? allBusinesses : allBusinesses.slice(0, 1);
        return <section className="context-organization" key={organization.id}><header><span><Building2 size={20} /></span><div><small>Organización</small><h3>{organization.name}</h3></div></header><div className="context-businesses">{businesses.map((business) => {
          const allBranches = workspace.workspace?.branches.filter((item) => item.businessId === business.id) ?? [];
          const branches = saas.hasFeature('multiBranch') ? allBranches : allBranches.slice(0, 1);
          return <article className="context-business" key={business.id}><div className="context-business__header"><span style={{ background: business.primaryColor }}><Store size={19} /></span><div><h4>{business.name}</h4><p>{business.industry}</p></div></div><div className="context-branches">{branches.map((branch) => {
            const active = current?.businessId === business.id && current?.branchId === branch.id;
            return <button key={branch.id} className={active ? 'is-active' : ''} onClick={() => select(organization.id, business.id, branch.id)}><MapPin size={17} /><span><strong>{branch.name}</strong><small>{branch.address || 'Dirección pendiente'}</small></span>{active ? <CircleCheck size={19} /> : <ArrowRight size={17} />}</button>;
          })}</div><footer><span>{branches.length} {branches.length === 1 ? 'sucursal' : 'sucursales'}</span>{saas.hasFeature('publicCatalog')&&<Button size="sm" variant="ghost" onClick={() => navigate(`/catalogo/${business.catalogSlug}`)}>Ver catálogo</Button>}</footer></article>;
        })}</div></section>;
      })}</div>
    </div>
  );
}
